import { FlexLayout } from '../../components';

/**
 * 셀 안쪽 여백을 어느 쪽에 줄 것인가.
 *
 * `AutoPadding.make` 은 이 판단을 하고 **남의 element props 를 직접 고치거나**
 * (`p.style.paddingLeft = 12`) div 를 하나 더 씌워서 여백을 넣었다. props 를 고치는
 * 것은 React 가 금지하는 일이고, 씌운 div 는 행마다 열 수만큼 늘어나 구형 PC 에서
 * 그대로 비용이 됐다. 판단만 떼어 내고, 여백은 **셀 자신의 클래스**로 준다.
 */
export function paddingSideOf(item: any): 'start' | 'end' | null {
  if (item?.type?.DOM_NAME !== 'FlexLayout') return null;
  const p = item.props;
  if (p.isVertical || p.align?.toUpperCase() !== 'CENTER') return null;
  if (p.style?.padding || p.style?.paddingLeft || p.style?.paddingRight) return null;

  const justify = p.justify?.toUpperCase();
  if (justify === 'LEFT' || justify === 'START') return 'start';
  if (justify === 'RIGHT' || justify === 'END') return 'end';
  return null;
}

/**
 * 셀 상자의 스타일 — 여백을 받는 셀이고 내용이 제 배경색을 가졌으면 **상자도 그 색으로** 칠한다.
 *
 * 여백(`paddingSideOf`)은 셀 상자에 붙는다. 화면이 내용 element 에 배경색을 칠하면
 * (연차관리의 `backgroundColor: '#B2EBF4'`) 그 색은 내용까지만 닿고 여백 12px 은 줄 배경색
 * 띠로 남았다(2026-10-08). 예전처럼 내용의 padding 을 고치지 않고 상자가 색을 물려받는다.
 * 그런 셀에서만 새 객체를 만든다 — 나머지는 받은 `base` 를 그대로 돌려 memo 를 깨지 않는다.
 */
export function tintedCellStyle<T extends object>(base: T, item: any): T {
  const tint = item?.props?.style?.backgroundColor;
  if (!tint || !paddingSideOf(item)) return base;
  return { ...base, backgroundColor: tint };
}

export default class AutoPadding {
  static make(item: any): any {
    let rowItem = item;

    if (rowItem && rowItem?.type?.DOM_NAME === 'FlexLayout') {
      const p = rowItem.props;
      if (!p.isVertical && p.align?.toUpperCase() === 'CENTER') {
        if (
          (p.justify?.toUpperCase() === 'LEFT' || p.justify?.toUpperCase() === 'START')
          && (!p.style?.padding && !p.style?.paddingLeft)
        ) {
          if (p.style) {
            p.style.paddingLeft = 12;
          } else {
            rowItem = <FlexLayout style={{ paddingLeft: 12 }}>{rowItem}</FlexLayout>;
          }
        } else if (
          (p.justify?.toUpperCase() === 'RIGHT' || p.justify?.toUpperCase() === 'END')
          && (!p.style?.padding && !p.style?.paddingRight)
        ) {
          if (p.style) {
            p.style.paddingRight = 12;
          } else {
            rowItem = <FlexLayout style={{ paddingRight: 12 }}>{rowItem}</FlexLayout>;
          }
        }
      }
    }

    return rowItem;
  }
}
